import { Component, EventEmitter, Input, OnChanges, Output, SimpleChanges } from '@angular/core';
import { FormControl, FormGroup, Validators } from '@angular/forms';
import { ApiService } from 'src/app/core/services/api.service';

@Component({
  selector: 'app-add-change-assessment',
  templateUrl: './add-change-assessment.component.html',
  styleUrls: ['./add-change-assessment.component.scss']
})
export class AddChangeAssessmentComponent implements OnChanges {
  @Input() skillName: string;
  @Input() jobTitle: string;
  @Input() branches: string[];
  @Input() skillAssessmentId: string;
  @Input() Level: 'junior' | 'middle' | 'senior';
  @Output() close = new EventEmitter<boolean>();
  isSubmitted = false;

  searchGlobalForm = new FormControl('');
  filteredSkills: string[] = [];
  form = new FormGroup({
    id: new FormControl(''),
    jobTitle: new FormControl(''),
    branches: new FormControl([]),        // multiselect, if any
    skill: new FormControl(''),
    type: new FormControl(0),
    levels: new FormControl([]),          // multiselect, if any
    referenceId: new FormControl('', Validators.required),
    assessmentTool: new FormControl('')
  });



  constructor(private apiService: ApiService) { }

  ngOnChanges(changes: SimpleChanges): void {
    let type: number;
    if (this.skillName && this.skillName.trim() !== '') {
      type = 3;
    } else if (this.branches.length > 0) {
      type = 2;
    } else {
      type = 1;
    }

    this.form.get('type')?.setValue(type);

    if (changes['Level'] && this.Level) {
      this.form.get('levels')?.setValue([this.Level]);
    }
    this.form.get('skill')?.setValue(this.skillName);

    if (changes['skillAssessmentId'] && this.skillAssessmentId) {
      this.apiService.getSkillAssessmentbyId(this.skillAssessmentId).subscribe({
        next: (res) => {
          if (res.data) {
            this.form.patchValue({
              referenceId: res.data.referenceId,
              assessmentTool: res.data.assessmentTool,
              id: res.data.id,
              skill: res.data.skill,
              type: res.data.type,
              levels: res.data.levels || [this.Level], // fallback to current seniority
            });
          }
        },
        error: (err) => {
          console.error('Error fetching assessment:', err);
        }
      });
    }
  }

  skillChanged(selected: string) {
    this.skillName = selected;
    this.searchGlobalForm.setValue(selected); // optional: sync input
  }

  onConfirm() {
    this.isSubmitted = true;
    if (this.form.valid) {
      const dto = this.form.value;

      this.apiService.postSkillAssessment(dto).subscribe({
        next: (res) => {
          this.close.emit(true);
        },
        error: (err) => {
        }
      });
    } else {
    }
  }

  onCancel() {
    this.close.emit(false);
  }
}

